import { Component, OnInit } from '@angular/core';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {ApiCredentials} from '../../Interfaces/ApiCredentials';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-api-subscription',
  templateUrl: './api-subscription.component.html',
  styleUrls: ['./api-subscription.component.css']
})
export class ApiSubscriptionComponent implements OnInit {
  subscription: Subscription;
  private clientRequest: ClientRequest;
  private apiCreds: ApiCredentials;
  myUser: User;
  apiSid: string;
  apiToken: string;




  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService, private  globalEventsManager: GlobalEventsManager,public myApp: AppComponent, private queryService: QueryService) {
    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active = "Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = " ";
    this.myUser.company_code = "EGN"
    this.myUser.company_code = "M0995"
    this.myUser.company_name = "MAHER TERMINALS, LLC"
    this.myUser.city = "HOUSTON"
    this.myUser.email_address = "miller@maherterminals.com"
    this.myUser.fax_number = null
    this.myUser.first_name = "Csp Craig"
    this.myUser.last_name = "Miller"
    this.myUser.maherError = null
    this.myUser.old_password = null
    this.myUser.password = ""
    this.myUser.phone_number = null
    this.myUser.company_scac = null
    this.myUser.state = "TX"
    this.myUser.userMenuReportItemsView = null
    this.myUser.user_gkey = "8237887"
    this.myUser.role = "AGENT"
    //  this.myUser.role= "LINEOP"
    // this.myUser.role= "HAULIER"
    this.myUser.username = "CSPCRAIG"
    this.myUser.zip = "07201"
    this.myUser.canSeeAllData = "1";

*/
  }

  ngOnInit() {
    this.getKeys();
  }


  getKeys(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.apiSubscriptionGetAPICreds(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (apis) => {
        this.apiCreds = apis;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          if (this.apiCreds==null){
            this.apiSid =  " ";
            this.apiToken = " ";
          }else{
            this.apiSid =  this.apiCreds.api_sid;
            this.apiToken = this.apiCreds.api_token;
          }
      });
  }

  generateKeys(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.apiSubscriptionGenerateAPICreds(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (apis) => {
        this.apiCreds = apis;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.apiCreds!=null){
          this.apiSid =  this.apiCreds.api_sid;
          this.apiToken = this.apiCreds.api_token;
        }
      });
  }
}
// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}
